// Utility: replace ASCII accidentals with musical symbols
// - Sharp: ♯ (U+266F)
// - Flat:  ♭ (U+266D)
// - Natural: ♮ (U+266E)

export function formatAccidentals(input) {
  if (input == null) return input;
  const s = String(input);
  return s
    // Replace any run of accidentals (#, b, n) after an uppercase note letter
    // (handles double/triple, etc.)
    // Examples: C## -> C♯♯, Ebb -> E♭♭, Fn -> F♮
    .replace(/([A-G])([#bn]+)/g, (_match, note, acc) =>
      note + acc.replace(/#/g, '♯').replace(/b/g, '♭').replace(/n/g, '♮')
    );
}

export default formatAccidentals;
